export const isRealtorsForum = (pathname: string = '') => (
  pathname.includes('forum-rieltorov')
);
